/* LinguaGuard — interaction layer */
(function () {
  'use strict';

  /* ---- Sticky header shadow on scroll ---- */
  const header = document.querySelector('.site-header');
  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('scrolled', window.scrollY > 8);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---- Mobile nav ---- */
  const toggle = document.querySelector('.nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', () => {
      document.body.classList.toggle('nav-open');
      const open = document.body.classList.contains('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.querySelectorAll('.nav-links a').forEach((a) =>
      a.addEventListener('click', () => document.body.classList.remove('nav-open'))
    );
  }

  /* ---- Reveal on scroll ---- */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---- Product gallery (products page) ---- */
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.src = thumb.getAttribute('data-thumb');
        gallery.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  });

  /* ---- Mock form submit ---- */
  document.querySelectorAll('form[data-mock]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const note = form.querySelector('[data-mock-note]');
      form.querySelectorAll('input, textarea, select, button').forEach((el) => (el.disabled = true));
      if (note) {
        note.textContent = 'Thank you — this is a staging mockup, so nothing was sent. The live form will route to info@linguaguard.com.';
        note.style.color = 'var(--blue)';
      }
    });
  });

  /* ---- Mock add-to-cart (products page) ---- */
  document.querySelectorAll('[data-cart]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const body = btn.closest('.pdp-body') || btn.closest('.product-body');
      const note = body && body.querySelector('[data-cart-note]');
      if (note) {
        note.textContent = 'Staging mockup — cart and checkout activate when this moves to Shopify.';
        note.style.color = 'var(--blue)';
      }
    });
  });

  /* ---- Footer year ---- */
  const yr = document.querySelector('[data-year]');
  if (yr) yr.textContent = new Date().getFullYear();
})();
